<template>
  <b-modal ref="addDocModal"
           id="modal-add-doc"
           title="Добавить ответ на вопрос"
           hide-footer>
      <b-form @submit="onSubmit" @reset="onReset" class="w-100">
      <alertMsg :message="alertMessage" v-if="showAlert"></alertMsg>
      <b-form-group id="form-title-group-name">
        <b-form-input id="name"
                        type="text"
                        placeholder="Введите название"
                        v-model="addForm.name"
                        required>

        </b-form-input>
      </b-form-group>
      <b-form-group>
        <b-form-select v-model="addForm.type" :options="options"></b-form-select>
      </b-form-group>
      <b-form-group id="form-title-group-sort">
        <b-form-input id="sort"
                        type="number"
                        placeholder="Введите порядок (больше — выше)"
                        v-model="addForm.sort"
                        required>

        </b-form-input>
      </b-form-group>
      <b-form-group id="form-title-group-link">
        <b-form-input id="link"
                        type="text"
                        placeholder="Введите ссылку на файл"
                        v-model="addForm.link"
                        >

        </b-form-input>
      </b-form-group>
        или
      <b-form-group id="form-title-group-file">
        <b-form-file id="file"
                      v-model="addForm.file">

        </b-form-file>
      </b-form-group>
      <b-button type="submit" variant="success">Добавить</b-button>
      <b-button type="reset" variant="">Отмена</b-button>
    </b-form>
  </b-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import axios from 'axios';
import alertMsg from '../common/AlertMsg';

export default {
  components: {
    alertMsg,
  },
  name: 'modalAdd',
  data() {
    return {
      addForm: {
        name: '',
        link: '',
        file: '',
        type: '',
      },
      alertMessage: 'Error',
      showAlert: false,
      options: [
        { value: 0, text: 'Без категории' },
        { value: 1, text: 'Нормативные документы' },
        { value: 2, text: 'Образцы заявлений' },
        { value: 3, text: 'Другое' },
      ]
    };
  },
  computed: {
    ...mapState({
      host: state => state.host,
    }),
    isAuthorised() {
      return this.$store.getters.isAuthorised;
    },
  },
  methods: {
    ...mapActions([
      'alertMsg', // -> this.alertMsg()
    ]),
    addItem(payload) {
      this.showAlert = false;
      const id = 'modal-add-doc';
      const path = this.host + 'add_doc';
      axios.post(path, payload, { headers: { 'Authorization': `Bearer ${localStorage.token}`, 'Content-Type': 'multipart/form-data' } })
        .then((res) => {
          if (res.data.status === 'success') {
            this.$bvModal.hide(id);
            this.$emit('docs');
            this.alertMsg({
              alert: res.data.message,
              type: 'success',
            });
          } else {
            this.alertMessage = `${res.data.status}: ${res.data.error}`;
            this.showAlert = true;
          }
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error);
        });
    },
    onSubmit(evt) {
      evt.preventDefault();
      let payload = new FormData();
      payload.append('name', this.addForm.name);
      payload.append('link', this.addForm.link);
      payload.append('type', this.addForm.type);
      payload.append('sort', this.addForm.sort);
      payload.append('file', document.getElementById('file').files[0]);
      this.addItem(payload);
      this.initForm();
    },
    onReset(evt) {
      evt.preventDefault();
      this.$bvModal.hide('modal-add-doc');
      this.initForm();
    },
    initForm() {
      this.addForm.name = '';
      this.addForm.link = '';
      this.addForm.file = '';
      this.addForm.type = '';
      this.addForm.sort = '';
    },
  },
  created() {
  },
};
</script>

<style scoped>

</style>
